import { SETTINGS_PATH } from 'cpmWorkspaces/navigation';

module.exports = {
  path: SETTINGS_PATH,
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/WorkspaceSettings'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/cpm/routes/workspaces/routes/show/routes/settings/index.js